// extracted by mini-css-extract-plugin
export default {"card":"CardProject_card__rpkxl","button_more":"CardProject_button_more__kAxn3","button_more_hide":"CardProject_button_more_hide__8H+af"};